import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconThumbUpComponent } from "./med-icon-thumb-up.component";

@NgModule({
  declarations: [
    MedIconThumbUpComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconThumbUpComponent,
  ],
})
export class MedIconThumbUpModule { }
